<template>
  <div v-show="productSubTypeData?.productTypeOptions?.data.length !== 0">
    <GridWrapper>
      <SectionSet isFirst>
        <div class="grid-wrapper grid grid-cols-6 items-center gap-x-6 laptop:grid-cols-12">
          <div class="order-1 col-span-6 col-start-1 laptop:col-span-7 laptop:col-start-2">
            <BreadCrumbs
              class="text-lg uppercase leading-[1.2] tracking-[0.08em] text-ng70 laptop:text-xl laptop:leading-[1.7]"
            />
            <div class="flex items-center text-lg leading-[1.4] laptop:text-[32px]">
              <div class="flex capitalize">
                {{
                  productSubTypeData?.productTypeOptions?.data[0]?.attributes?.product_type?.data?.attributes
                    ?.page_title
                }}
                <span class="ml-2.5 leading-[1]">→</span>

                <HeadlessListbox v-slot="{ open }" v-model="route.params.subtype">
                  <div class="relative">
                    <HeadlessListboxButton
                      class="relative flex items-center rounded-lg px-2.5 text-left text-ng600 hover:bg-ng20 hover:text-ng800 focus:outline-none focus-visible:ring focus-visible:ring-ng70 focus-visible:ring-opacity-75"
                      :class="{ '!text-ng800': open, 'bg-ng20': open }"
                    >
                      {{
                        productSubTypeData?.allProductTypeOptions?.data.filter(
                          (type) => type.attributes?.slug === route.params.subtype,
                        )[0]?.attributes?.name
                      }}
                      <DownArrow :rotate="open" icon="dashicons:arrow-down-alt2" />
                    </HeadlessListboxButton>
                    <DropdownTransition>
                      <HeadlessListboxOptions
                        class="absolute right-0 z-20 mt-2 max-h-60 w-[250px] max-w-sm overflow-auto bg-white py-2 shadow-dropdown desktopLarge:left-0"
                      >
                        <HeadlessListboxOption
                          v-slot="{ active, selected }"
                          v-for="item in productSubTypeData?.allProductTypeOptions?.data"
                          :key="item.attributes?.slug"
                          :value="item.attributes?.slug"
                          class="w-full"
                        >
                          <NuxtLink
                            :to="
                              localePath({
                                name: 'products-type-subtype',
                                params: {
                                  type: item.attributes?.product_type?.data?.attributes?.slug || '',
                                  subtype: item.attributes?.slug || '',
                                },
                              })
                            "
                            class="flex w-full py-1 px-4 text-base laptop:text-xl"
                            :class="{
                              'font-bold text-ng800': selected,

                              'bg-ng20': active,
                            }"
                          >
                            {{ item.attributes?.name }}
                          </NuxtLink>
                        </HeadlessListboxOption>
                      </HeadlessListboxOptions>
                    </DropdownTransition>
                  </div>
                </HeadlessListbox>
              </div>
            </div>
            <p class="subtitle">
              {{ productProductTypeOptionsPageData?.productsProductTypeOptionsPage?.data?.attributes?.hero_subtitle }}
            </p>
          </div>
          <img
            class="order-3 col-span-2 col-start-1 laptop:absolute laptop:top-[220px] laptop:left-1/2 laptop:order-2 laptop:-ml-[69px]"
            src="/images/greece-map-2.png"
            alt="Map of Greece"
          />
          <div
            class="order-2 col-span-5 mt-[9px] mb-[19px] flex laptop:order-3 laptop:col-span-3 laptop:col-end-12 laptop:mb-0 laptop:mt-0 laptop:justify-end desktop:mt-0"
          >
            <DownloadBtn
              class="max-w-fit laptop:self-end"
              :text="$t('download-type-brochure')"
              v-if="
                productSubTypeData?.productTypeOptions?.data[0]?.attributes?.product_type?.data?.attributes?.brochure
                  ?.data?.attributes?.url
              "
              :href="
                productSubTypeData?.productTypeOptions?.data[0]?.attributes?.product_type?.data?.attributes?.brochure
                  ?.data?.attributes?.url
              "
            />
          </div>
        </div>
        <div class="mx-auto flex w-full flex-col laptop:mt-[100px]">
          <div
            class="flex w-full justify-center space-x-[30px] self-center min-[400px]:space-x-[50px] tablet:space-x-[80px] laptop:space-x-[193px] laptop:self-auto"
          >
            <template
              v-if="
                productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data &&
                productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data?.length > 0
              "
            >
              <BrandsVariety
                v-for="variety in productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data"
                :key="JSON.stringify(variety)"
                :image="variety?.attributes?.icon?.data?.attributes?.url || ''"
                :alt="variety?.attributes?.icon?.data?.attributes?.alternativeText || ''"
                :area="variety?.attributes?.name || ''"
                class="cursor-default"
              />
            </template>
            <template v-else>
              <BrandsVariety
                :image="productSubTypeData?.productTypeOptions?.data[0]?.attributes?.icon?.data?.attributes?.url || ''"
                :alt="
                  productSubTypeData?.productTypeOptions?.data[0]?.attributes?.icon?.data?.attributes
                    ?.alternativeText || ''
                "
                class="cursor-default"
                :area="productSubTypeData?.productTypeOptions?.data[0]?.attributes?.name || ''"
              />
            </template>
          </div>
          <div class="grid-wrapper grid grid-cols-6 items-center gap-x-6 laptop:grid-cols-12">
            <p class="col-span-6 col-start-1 mt-12 laptop:col-span-10 laptop:col-start-2">
              <!--              {{ productProductTypeOptionsPageData?.productsProductTypeOptionsPage?.data?.attributes?.hero_paragraph }}-->
              <span class="block mx-auto max-w-[718px]">
                {{ productSubTypeData?.productTypeOptions?.data[0]?.attributes?.hero_paragraph_1 }}
              </span>
            </p>
          </div>
        </div>
      </SectionSet>
      <SectionSet
        v-if="
          (productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data &&
            productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data?.length > 0) ||
          (productSubTypeData?.productTypeOptions?.data[0]?.attributes?.product_cuts?.data &&
            productSubTypeData?.productTypeOptions?.data[0]?.attributes?.product_cuts?.data?.length > 0)
        "
      >
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h2 class="col-span-6 mb-8 laptop:col-start-2 laptop:mb-14">
            {{ $t("cuts") }}
          </h2>
          <div
            class="col-span-6 space-y-6 laptop:col-span-10 laptop:col-start-2 laptop:space-y-14"
            v-if="
              productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data &&
              productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data?.length > 0
            "
          >
            <div
              class="flex laptop:justify-between laptop:items-end flex-wrap"
              v-for="subtype in productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data"
              :key="subtype.attributes?.slug"
            >
              <ProductCutsSizes
                v-for="(cut, index) in subtype?.attributes?.product_cuts?.data"
                :key="JSON.stringify(cut)"
                class="col-span-3 laptop:col-span-2 laptop:col-start-2 laptop:w-[20%] w-[50%]"
                :class="`col-start-${1 + 3 * (index % 2)} laptop:col-start-${2 + 2 * (index % 5)}`"
                :title="cut.attributes?.name || ''"
                :image="getImageForCut(subtype.attributes?.slug, cut?.attributes?.image?.data) || ''"
                :cuts="true"
              />
            </div>
          </div>

          <div class="col-span-6 space-y-6 laptop:col-span-10 laptop:col-start-2 laptop:space-y-14" v-else>
            <div class="flex laptop:justify-between laptop:items-end flex-wrap">
              <ProductCutsSizes
                v-for="(cut, index) in productSubTypeData?.productTypeOptions?.data[0]?.attributes?.product_cuts?.data"
                :key="JSON.stringify(cut)"
                class="col-span-3 laptop:col-span-2 laptop:col-start-2 laptop:w-[20%] w-[50%]"
                :class="`col-start-${1 + 3 * (index % 2)} laptop:col-start-${2 + 2 * (index % 5)}`"
                :title="cut.attributes?.name || ''"
                :image="
                  getImageForCut(
                    productSubTypeData?.productTypeOptions?.data[0]?.attributes?.slug,
                    cut?.attributes?.image?.data,
                  ) || ''
                "
                :cuts="true"
              />
            </div>
          </div>
        </div>
      </SectionSet>
      <SectionSet v-if="productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data.length">
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h2 class="col-span-3 mb-8 laptop:col-start-2 laptop:mb-14">{{ $t("variations") }}</h2>
          <div class="col-span-6 laptop:col-span-12 laptop:col-start-2">
            <div class="flex flex-col">
              <div class="table-parent">
                <div class="table-container">
                  <table class="tabla-resumen">
                    <thead>
                      <tr>
                        <th class="bg-[#FCFFFB]">{{ $t("variations") }}</th>
                        <th class="spacer" />
                        <th
                          class="item"
                          v-for="variety in productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data"
                          :key="variety.attributes?.slug"
                        >
                          {{ variety.attributes?.name }}
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="variation in uniqueProductTypeVariations" :key="JSON.stringify(variation)">
                        <td class="bg-[#FCFFFB]">{{ variation?.name }}</td>
                        <td class="spacer" />

                        <td
                          class="item"
                          v-for="variety in productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data"
                          :key="variety.attributes?.slug"
                        >
                          {{ checkIfVarietyHasVariation(variety, variation) }}
                        </td>
                        <td class="!w-full" />
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-span-6 mt-8 space-y-2 text-sm font-light italic"></div>
            </div>
          </div>
        </div>
      </SectionSet>

      <SectionSet
        v-else-if="
          productSubTypeData?.productTypeOptions?.data[0]?.attributes?.product_variations &&
          uniqueProductTypeVariations.length
        "
      >
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h2 class="col-span-3 mb-8 laptop:col-start-2 laptop:mb-14">{{ $t("variations") }}</h2>
          <div class="col-span-6 laptop:col-span-12 laptop:col-start-2">
            <div class="flex flex-col">
              <div class="table-parent">
                <div class="table-container">
                  <table class="tabla-resumen">
                    <thead>
                      <tr>
                        <th class="bg-[#FCFFFB]">{{ $t("variations") }}</th>
                        <th class="spacer" />
                        <th class="item">
                          {{ productSubTypeData?.productTypeOptions?.data[0]?.attributes.name }}
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="variation in uniqueProductTypeVariations" :key="JSON.stringify(variation)">
                        <td class="bg-[#FCFFFB]">{{ variation?.name }}</td>
                        <td class="spacer" />

                        <td class="item !w-full">
                          {{ $t("yes") }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-span-6 mt-8 space-y-2 text-sm font-light italic"></div>
            </div>
          </div>
        </div>
      </SectionSet>

      <SectionSet
        v-if="
          (productTypeStuffings && productTypeStuffings.length) || (productTypeAdditions && productTypeAdditions.length)
        "
      >
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h2 class="col-span-3 mb-8 laptop:col-start-2 laptop:mb-14">{{ $t("additionsAndStuffings") }}</h2>
          <div class="col-span-6 laptop:col-span-12 laptop:col-start-2">
            <div class="flex flex-col">
              <div class="table-parent">
                <div class="table-container">
                  <table class="tabla-resumen">
                    <thead>
                      <tr>
                        <th class="bg-[#FCFFFB]">{{ $t("Options") }}</th>
                        <th class="spacer" />
                        <th class="item">{{ $t("Ingredients") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="productTypeAdditions && productTypeAdditions.length">
                        <td class="bg-[#FCFFFB]">
                          <div>{{ $t("Additions") }}</div>
                          <div
                            class="text-xs"
                            v-for="[addition, value] in typeAdditionMap"
                            :key="JSON.stringify(addition)"
                          >
                            {{ getType(addition, value) }}
                          </div>
                        </td>
                        <td class="spacer" />
                        <td class="item !w-full p-0">
                          {{ productAdditionsStringWithCommas }}
                        </td>
                      </tr>
                      <tr v-if="productTypeStuffings && productTypeStuffings.length">
                        <td class="bg-[#FCFFFB]">
                          <div>{{ $t("Stuffings") }}</div>
                          <div
                            class="text-xs"
                            v-for="[stuffing, value] in typeStuffingMap"
                            :key="JSON.stringify(stuffing)"
                          >
                            {{ getType(stuffing, value) }}
                          </div>
                        </td>
                        <td class="spacer" />
                        <td class="item !w-full p-0">
                          {{ productStuffingsStringWithCommas }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-span-6 mt-8 space-y-2 text-sm font-light italic"></div>
            </div>
          </div>
        </div>
      </SectionSet>
      <SectionSet v-if="productTypeSizes && productTypeSizes.length">
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <h2 class="col-span-3 mb-8 laptop:col-start-2 laptop:mb-14">
            {{ productSubTypeData?.productTypeOptions?.data[0]?.attributes?.name }} Sizes
          </h2>

          <div
            class="grid grid-cols-6 laptop:grid-cols-10 col-span-6 laptop:col-span-10 laptop:col-start-2 gap-x-5 gap-y-14"
          >
            <template v-for="(size, index) in productTypeSizes" :key="JSON.stringify(size)">
              <ProductSizeItem
                :title="size?.name || ''"
                :number="size?.size || ''"
                :width="size?.width || ''"
                :height="size?.height || ''"
                :image="sizeImageUrl"
              >
                <div
                  v-if="
                    productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data &&
                    productSubTypeData?.productTypeOptions?.data[0]?.attributes?.subtypes?.data?.length > 0
                  "
                  class="px-2 text-xs"
                >
                  <span class="" v-if="size?.subTypesThatHaveTheSize.all !== true">{{ getMapString(size).stars }}</span>
                  <span v-else>&nbsp;</span>
                  <span v-if="size?.subTypesThatHaveTheSize.all !== true" class="hidden text-xs laptop:inline italic"
                    >{{ $t("available_in") }} {{ getTypesSizeAvailabilityString(size) }}</span
                  >
                  <span v-else>&nbsp;</span>
                </div>
              </ProductSizeItem>
            </template>
            <div class="col-span-6 mt-8 space-y-2 text-sm font-light italic laptop:hidden">
              <div v-for="[size, value] in typeSizeMap" :key="JSON.stringify(size)">
                {{ getType(size, value) }}
              </div>
            </div>
          </div>
        </div>
      </SectionSet>
    </GridWrapper>
    <!--    <SectionSet>
      <div class="flex flex-col">
        <CustomizationSection class="w-full" />
      </div>
    </SectionSet>-->
    <GridWrapper>
      <SectionSet>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div class="col-span-6 flex flex-col laptop:col-span-10 laptop:col-start-2">
            <h2 class="text-right capitalize laptop:text-left">
              {{ $t("available") }}

              <HighlightedLink :to="{ name: 'products-packaging' }" class="link px-0">
                <span class="underlined relative leading-[1.2]"> {{ $t("packagings") }} </span>
              </HighlightedLink>
            </h2>

            <NuxtLink :to="localePath({ name: 'products-packaging' })">
              <img class="mt-12 laptop:mt-[56px]" src="/images/packages.png" alt="packages" />
            </NuxtLink>
          </div>
          <div
            class="col-span-6 mt-8 justify-between text-center laptop:col-span-10 laptop:col-start-2 laptop:mt-[56px] laptop:flex"
          >
            <h3>
              {{
                productProductTypeOptionsPageData?.productsProductTypeOptionsPage?.data?.attributes?.packaging_sizes[0]
                  ?.title
              }}
            </h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>
              {{
                productProductTypeOptionsPageData?.productsProductTypeOptionsPage?.data?.attributes?.packaging_sizes[1]
                  ?.title
              }}
            </h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>
              {{
                productProductTypeOptionsPageData?.productsProductTypeOptionsPage?.data?.attributes?.packaging_sizes[2]
                  ?.title
              }}
            </h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>
              {{
                productProductTypeOptionsPageData?.productsProductTypeOptionsPage?.data?.attributes?.packaging_sizes[3]
                  ?.title
              }}
            </h3>
            <h3 class="hidden laptop:block">/</h3>
            <h3>
              {{
                productProductTypeOptionsPageData?.productsProductTypeOptionsPage?.data?.attributes?.packaging_sizes[4]
                  ?.title
              }}
            </h3>
          </div>
          <div
            class="col-span-6 mt-8 flex flex-col items-center justify-between laptop:col-span-10 laptop:col-start-2 laptop:mt-[56px] laptop:flex-row"
          >
            <NextBtn
              class="col-span-6 laptop:col-span-3"
              :text="$t('learn-more-about-packaging-options')"
              :to="localePath({ name: 'products-packaging' })"
            />
            <div class="col-span-6 mt-3.5 laptop:col-span-3 laptop:col-start-9 laptop:justify-end">
              <DownloadBtn
                :text="'DOWNLOAD PACKAGING BROCHURE'"
                v-if="
                  productSubTypeData?.productTypeOptions?.data[0]?.attributes?.product_type?.data?.attributes
                    ?.packaging_brochure?.data?.attributes?.url
                "
                :href="
                  productSubTypeData?.productTypeOptions?.data[0]?.attributes?.product_type?.data?.attributes
                    ?.packaging_brochure?.data?.attributes?.url
                "
              />
            </div>
          </div>
        </div>
      </SectionSet>
    </GridWrapper>
    <SectionSet isLast>
      <div class="flex justify-center">
        <NextBtn :text="$t('Back to top')" :isRotated="true" @click="scrollToTop()" />
      </div>
    </SectionSet>
  </div>
</template>
<script setup lang="ts">
import { generateDynamicTitle } from "~~/utilities/dynamic-title";
import { LoadingBarKey } from "~/symbols/symbols";
import { scrollToTop } from "~/utilities/utils";
const loadingBarIndicator = inject(LoadingBarKey);

const { t } = useI18n();

const localePath = useLocalePath();

definePageMeta({
  validate: async (route) => {
    if (route.params.subtype === undefined) return false;
    const { data } = await useAsyncGql({
      operation: "CheckIfProductSubTypeExists",
      variables: { slug: route.params.subtype as string },
      options: {
        lazy: true,
      },
    });
    if (data?.value?.productTypeOptions?.data?.length === 0) {
      return false;
    } else {
      return true;
    }
  },
});

function checkIfVarietyHasVariation(variety, variation) {
  return (variety?.attributes?.product_variations?.data || []).some(
    (productVariation) => productVariation.attributes.name === variation.name,
  )
    ? t("yes")
    : "-";
}

const { locale, finalizePendingLocaleChange } = useI18n();

const route = useRoute();

await finalizePendingLocaleChange();

const title = generateDynamicTitle(route);

useHead({
  title: `${title}`,
});

function getType(size, value) {
  const subtypes = value.subTypes.map((type) => type.attributes.name);

  if (subtypes.length) {
    return `${value.stars}${t("available_in")} ${subtypes.join(", ").replace(/,(?!.*,)/gim, " & ")}`;
  }
}

useServerSeoMeta({
  title: () => `${title}`,
  ogTitle: () => `${title}`,
  description: () => "",
  ogDescription: () => "",
  ogImage: () => "",
});

loadingBarIndicator?.value?.indicator?.start();
const { data: productProductTypeOptionsPageData } = await useAsyncGql({
  operation: "ProductsProductTypeOptionPage",
  variables: { locale: locale.value },
  options: {
    lazy: false,
  },
});

const { data: productSubTypeData } = await useAsyncGql({
  operation: "GetProductSubTypeData",
  variables: {
    locale: locale.value,
    product_type_option: route.params.subtype as string,
    product_type: route.params.type as string,
  },
  options: {
    lazy: false,
  },
});

const uniqueProductTypeVariations = computed(() => {
  if (
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data &&
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data?.length > 0
  ) {
    const allProductVariations =
      productSubTypeData.value?.productTypeOptions?.data[0].attributes?.subtypes?.data.flatMap((subType) => {
        return subType.attributes?.product_variations?.data.flatMap((size) => {
          return size.attributes;
        });
      });

    const uniqueVariations = allProductVariations?.filter((variation, index, self) => {
      return (
        index ===
        self.findIndex((t) => {
          return t?.name === variation?.name;
        })
      );
    });

    return uniqueVariations;
  } else {
    return productSubTypeData.value?.productTypeOptions?.data[0].attributes?.product_variations?.data.map(
      (variation) => {
        return variation.attributes;
      },
    );
  }
});

if (productSubTypeData.value?.productTypeOptions?.data.length === 0) {
  const router = useRouter();

  router.replace({
    params: {
      type: productSubTypeData.value.lozalizedType?.data[0].attributes?.slug as string,
      subtype: productSubTypeData.value.lozalizedSubType?.data[0].attributes?.slug,
    },
  });
}
loadingBarIndicator?.value?.indicator?.finish();

function getMapString(size) {
  const stringMap = size.subTypesThatHaveTheSize.subTypes.map((t) => t.id);
  return typeSizeMap.get(stringMap.join(","));
}

function getStuffMapString(size) {
  const stringMap = size.subTypesThatHaveTheStuffing.subTypes.map((t) => t.id);
  return typeStuffingMap.get(stringMap.join(","));
}

function getAdditionsMapString(size) {
  const stringMap = size.subTypesThatHaveTheAddition.subTypes.map((t) => t.id);
  return typeAdditionMap.get(stringMap.join(","));
}

const productTypeSizes = computed(() => {
  if (
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data &&
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data?.length > 0
  ) {
    const allProductSizes = productSubTypeData.value?.productTypeOptions?.data[0].attributes?.subtypes?.data.flatMap(
      (subType) => {
        return subType.attributes?.product_type_option_sizes?.data.flatMap((size) => {
          return size.attributes;
        });
      },
    );

    const uniqueSizes = allProductSizes?.filter((size, index, self) => {
      return (
        index ===
        self.findIndex((t) => {
          return t?.slug === size?.slug;
        })
      );
    });

    const uniqueSizesWithSubTypeCount = uniqueSizes.map((size) => {
      const subTypesThatHaveTheSize =
        size?.product_type_options?.data.filter((type) => {
          return productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data.find(
            (type2) => type2.attributes?.slug === type.attributes?.slug,
          );
        }) || [];

      const allSubTypesHaveTheSize =
        subTypesThatHaveTheSize.length ===
        productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data.length;

      if (!allSubTypesHaveTheSize) {
        createSubTypeThatHaveTheSizeDictionary(subTypesThatHaveTheSize);
      }

      return {
        ...size,
        subTypesThatHaveTheSize: {
          all: allSubTypesHaveTheSize,
          subTypes: subTypesThatHaveTheSize,
        },
      };
    });

    uniqueSizesWithSubTypeCount.sort((a, b) => {
      if (parseInt(a?.size?.split("-")[0]) < parseInt(b?.size?.split("-")[0])) {
        return -1;
      }
      if (parseInt(a?.size?.split("-")[0]) > parseInt(b?.size?.split("-")[0])) {
        return 1;
      }
      return 0;
    });

    return uniqueSizesWithSubTypeCount;
  } else if (
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.product_type_option_sizes?.data &&
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.product_type_option_sizes?.data?.length > 0
  ) {
    return productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.product_type_option_sizes?.data.map(
      (size) => {
        return {
          ...size.attributes,
          subTypesThatHaveTheSize: {
            all: true,
            subTypes: [],
          },
        };
      },
    );
  }
});
const subTypeMap = ref(new Map());

const productTypeStuffings = computed(() => {
  if (
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data &&
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data?.length > 0
  ) {
    const allProductStuffings =
      productSubTypeData.value?.productTypeOptions?.data[0].attributes?.subtypes?.data.flatMap((subType) => {
        return subType.attributes?.product_stuffings?.data.flatMap((size) => {
          return size.attributes;
        });
      });

    const uniqueStuffings = allProductStuffings?.filter((stuffing, index, self) => {
      return (
        index ===
        self.findIndex((t) => {
          return t?.name === stuffing?.name;
        })
      );
    });

    const uniqueStuffingsWithSubTypeCount = uniqueStuffings.map((stuffing) => {
      const subTypesThatHaveTheStuffing =
        stuffing?.product_type_options?.data.filter((type) => {
          return productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data.find(
            (type2) => type2.attributes?.slug === type.attributes?.slug,
          );
        }) || [];

      const allSubTypesHaveTheStuffing =
        subTypesThatHaveTheStuffing.length ===
        productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data.length;

      if (!allSubTypesHaveTheStuffing) {
        createSubTypeThatHaveTheStuffingDictionary(subTypesThatHaveTheStuffing);
      }

      return {
        ...stuffing,
        subTypesThatHaveTheStuffing: {
          all: allSubTypesHaveTheStuffing,
          subTypes: subTypesThatHaveTheStuffing,
        },
      };
    });

    uniqueStuffingsWithSubTypeCount.sort((a, b) => {
      if (parseInt(a?.stuffing?.split("-")[0]) < parseInt(b?.stuffing?.split("-")[0])) {
        return -1;
      }
      if (parseInt(a?.stuffing?.split("-")[0]) > parseInt(b?.stuffing?.split("-")[0])) {
        return 1;
      }
      return 0;
    });
    return uniqueStuffingsWithSubTypeCount;
  } else if (
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.product_type_option_sizes?.data &&
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.product_type_option_sizes?.data?.length > 0
  ) {
    return productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.product_stuffings?.data.map(
      (stuffing) => {
        return {
          ...stuffing.attributes,
          subTypesThatHaveTheStuffing: {
            all: true,
            subTypes: [],
          },
        };
      },
    );
  }
});
const subTypeStuffingMap = ref(new Map());

const productStuffingsStringWithCommas = computed(() => {
  const arr = productTypeStuffings.value?.map((stuffing) => {
    if (stuffing?.subTypesThatHaveTheStuffing && stuffing?.subTypesThatHaveTheStuffing.all !== true) {
      return stuffing?.name + getStuffMapString(stuffing).stars;
    }
    return stuffing?.name;
  });
  if (arr) return arr.join(", ");
});

const productTypeAdditions = computed(() => {
  if (
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data &&
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data?.length > 0
  ) {
    const allProductAdditions =
      productSubTypeData.value?.productTypeOptions?.data[0].attributes?.subtypes?.data.flatMap((subType) => {
        return subType.attributes?.product_additions?.data.flatMap((size) => {
          return size.attributes;
        });
      });

    const uniqueAdditions = allProductAdditions?.filter((addition, index, self) => {
      return (
        index ===
        self.findIndex((t) => {
          return t?.name === addition?.name;
        })
      );
    });

    const uniqueAdditionsWithSubTypeCount = uniqueAdditions.map((addition) => {
      const subTypesThatHaveTheAddition =
        addition?.product_type_options?.data.filter((type) => {
          return productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data.find(
            (type2) => type2.attributes?.slug === type.attributes?.slug,
          );
        }) || [];

      const allSubTypesHaveTheAddition =
        subTypesThatHaveTheAddition.length ===
        productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data.length;

      if (!allSubTypesHaveTheAddition) {
        createSubTypeThatHaveTheAdditionDictionary(subTypesThatHaveTheAddition);
      }

      return {
        ...addition,
        subTypesThatHaveTheAddition: {
          all: allSubTypesHaveTheAddition,
          subTypes: subTypesThatHaveTheAddition,
        },
      };
    });

    uniqueAdditionsWithSubTypeCount.sort((a, b) => {
      if (parseInt(a?.addition?.split("-")[0]) < parseInt(b?.addition?.split("-")[0])) {
        return -1;
      }
      if (parseInt(a?.addition?.split("-")[0]) > parseInt(b?.addition?.split("-")[0])) {
        return 1;
      }
      return 0;
    });
    return uniqueAdditionsWithSubTypeCount;
  } else if (
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.product_type_option_sizes?.data &&
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.product_type_option_sizes?.data?.length > 0
  ) {
    return productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.product_additions?.data.map(
      (addition) => {
        return {
          ...addition.attributes,
          subTypesThatHaveTheAddition: {
            all: true,
            subTypes: [],
          },
        };
      },
    );
  }
});
const subTypeAdditionsMap = ref(new Map());

const productAdditionsStringWithCommas = computed(() => {
  const arr = productTypeAdditions.value?.map((addition) => {
    if (addition?.subTypesThatHaveTheAddition && addition?.subTypesThatHaveTheAddition.all !== true) {
      return addition?.name + getAdditionsMapString(addition).stars;
    }
    return addition?.name;
  });
  if (arr) return arr.join(", ");
});

function createSubTypeThatHaveTheStuffingDictionary(subTypes) {
  const mapSub = subTypes.flatMap((s) => s.id);

  subTypeStuffingMap.value.set(mapSub.join(","), "*".repeat(subTypeStuffingMap.value.size + 1));
}

function createSubTypeThatHaveTheSizeDictionary(subTypes) {
  const mapSub = subTypes.flatMap((s) => s.id);

  subTypeMap.value.set(mapSub.join(","), "*".repeat(subTypeMap.value.size + 1));
}

function createSubTypeThatHaveTheAdditionDictionary(subTypes) {
  const mapSub = subTypes.flatMap((s) => s.id);

  subTypeAdditionsMap.value.set(mapSub.join(","), "*".repeat(subTypeAdditionsMap.value.size + 1));
}

const counter = ref(1);
const typeSizeMap = productTypeSizes.value?.reduce((acc, size, index) => {
  const subTypes = size.subTypesThatHaveTheSize.subTypes.map((type) => type.id);
  if (size.subTypesThatHaveTheSize.all) return acc;
  const key = subTypes.join(",");

  if (acc.has(key)) {
    //
  } else {
    acc.set(key, { stars: "*".repeat(counter.value), subTypes: size.subTypesThatHaveTheSize.subTypes });
    counter.value++;
  }
  return acc;
}, new Map());

const counter2 = ref(1);
const typeStuffingMap = productTypeStuffings.value?.reduce((acc, stuffing, index) => {
  const subTypes = stuffing.subTypesThatHaveTheStuffing.subTypes.map((type) => type.id);

  if (stuffing.subTypesThatHaveTheStuffing.all) return acc;
  const key = subTypes.join(",");

  if (acc.has(key)) {
  } else {
    acc.set(key, { stars: "*".repeat(counter2.value), subTypes: stuffing.subTypesThatHaveTheStuffing.subTypes });

    counter2.value++;
  }
  return acc;
}, new Map());

const counter3 = ref(1);
const typeAdditionMap = productTypeAdditions.value?.reduce((acc, addition, index) => {
  const subTypes = addition.subTypesThatHaveTheAddition.subTypes.map((type) => type.id);

  if (addition.subTypesThatHaveTheAddition.all) return acc;
  const key = subTypes.join(",");

  if (acc.has(key)) {
  } else {
    acc.set(key, { stars: "*".repeat(counter3.value), subTypes: addition.subTypesThatHaveTheAddition.subTypes });

    counter3.value++;
  }
  return acc;
}, new Map());

function getTypesSizeAvailabilityString(size) {
  const subtypes = size.subTypesThatHaveTheSize.subTypes.map((type) => type.attributes.name);

  if (subtypes.length) {
    return subtypes.join(", ").replace(/,(?!.*,)/gim, " & ");
  }
}

function getImageForCut(
  subTypeSlug: string | undefined,
  cutGallery:
    | {
        attributes: {
          alternativeText?: string | null | undefined;
          caption?: string | null | undefined;
          url?: string | null | undefined;
        };
      }[]
    | null
    | undefined,
) {
  if (!subTypeSlug || !cutGallery) return "";

  const item = cutGallery.find((cut) => {
    if (cut.attributes.caption) {
      return cut.attributes.caption.split(",").includes(subTypeSlug) ? true : false;
    } else {
      return false;
    }
  });

  return item?.attributes.url || "";
}

const sizeImageUrl = computed(() => {
  if (
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data &&
    productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data?.length > 0
  ) {
    const index = productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data.length - 1;
    return (
      productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.subtypes?.data[index]?.attributes?.icon?.data
        ?.attributes?.url || ""
    );
  } else {
    return productSubTypeData.value?.productTypeOptions?.data[0]?.attributes?.icon?.data?.attributes?.url || "";
  }

  //size?.image?.data[0]?.attributes?.url || ''
});
</script>
<style lang="scss" scoped></style>
